
<div class="right-side p-5">
  <h2 class="mb-2">Verify MSME</h2>
  <div class="section">
    <form [formGroup]="verifymsmeForm">
      <div class="row">
        <!-- Total Registration Card -->
        <!--<div class="col-md-4">
          <div class="card bg-gradient-primary box-shadow mb-2">
            <div class="card-body">
              <h5 class="card-title fs-5">Total Registration</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ totalRegistered }}</div>
                <i class="bi bi-people ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">Total No. of registrations received.</p>
            </div>
          </div>
        </div>-->

        <!-- Pending for Verification Card -->
        <!--<div class="col-md-2">
          <div class="card bg-gradient-warning box-shadow mb-2">
            <div class="card-body">
              <h5 class="card-title fs-5">Pending for verification</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ pendingVerification }}</div>
                <i class="bi bi-hourglass-split ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">No. of registrations awaiting verification.</p>
            </div>
          </div>
        </div>-->

        <!-- Approved Registration Card -->
        <!--<div class="col-md-2">
          <div class="card bg-gradient-success box-shadow mb-2">
            <div class="card-body">
              <h5 class="card-title fs-5">Approved Registration</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ approvedRegistration }}</div>
                <i class="bi bi-check-circle ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">No. of registrations have been approved.</p>
            </div>
          </div>
        </div>-->

        <!-- Rejected for Query Card -->
        <!--<div class="col-md-2">
          <div class="card bg-gradient-info box-shadow mb-2">
            <div class="card-body">
              <h5 class="card-title fs-5">Rejected for Query</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ rejectedForQuery }}</div>
                <i class="bi bi-question-circle ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">No. of registrations rejected due to queries.</p>
            </div>
          </div>
        </div>-->

        <!-- Rejected Registration Card -->
        <!--<div class="col-md-2">
          <div class="card bg-gradient-danger box-shadow mb-2">
            <div class="card-body">
              <h5 class="card-title fs-5">Rejected Registration</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ rejectedRegistration }}</div>
                <i class="bi bi-person-x ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">No. of registrations have been rejected.</p>
            </div>
          </div>
        </div>-->

        <!-- Total Registration Card -->
        <!--<div class="col-md-3 mb-4">
          <div class="card text-white bg-primary">
            <div class="card-header">
              Total Registration
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ totalRegistered }}</h5>
              <p class="card-text">Total number of registrations received.</p>
            </div>
          </div>
        </div>-->
        <!-- Pending for Verification Card -->
        <!--<div class="col-md-3 mb-4">
          <div class="card text-white bg-warning">
            <div class="card-header">
              Pending for verification
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ pendingVerification }}</h5>
              <p class="card-text">Number of registrations awaiting verification.</p>
            </div>
          </div>
        </div>-->
        <!-- Approved Registration Card -->
        <!--<div class="col-md-3 mb-4">
          <div class="card text-white bg-success">
            <div class="card-header">
              Approved Registration
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ approvedRegistration }}</h5>
              <p class="card-text">Number of registrations that have been approved.</p>
            </div>
          </div>
        </div>-->
        <!-- Rejected Registration Card -->
        <!--<div class="col-md-3 mb-4">
          <div class="card text-white bg-danger">
            <div class="card-header">
              Approved Registration
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ rejectedRegistration }}</h5>
              <p class="card-text">Number of registrations that have been rejected.</p>
            </div>
          </div>
        </div>-->

        <!--<hr />-->



        <div class="mt-1">
          <!--SEARCH-->
          <!--<div class="search">
    <div class="row">
      <div class="col-md-3 offset-md-8">
        <input matInput class="form-control" formControlName="search" />
      </div>
      <button class="col-md-1" type="submit" (click)="onSearchClick(verifymsmeForm.get('search')?.value ?? '')" id="btnSearch">
        <i class="bi bi-search fs-4"></i>
      </button>
      <div class="row-cols-md-6">
        <button class="col-md-1" type="reset" (click)="resetPage()" id="btnReset">
          <i class="bi bi-arrow-clockwise fs-4"></i>
        </button>
      </div>
    </div>
  </div>-->

          <div class="text-end">
            <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
          </div>
          <div class="col-lg-7 col-sm-12">
            <div class="search-container">
              <mat-form-field class="search-input w-75" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="search" />
              </mat-form-field>
              <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(verifymsmeForm.get('search')?.value ?? '')" id="btnSearch">
                <i class="bi bi-search fs-4"></i>
              </button>
              <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                <i class="bi bi-arrow-clockwise fs-4"></i>
              </button>
            </div>


          </div>

          <div class="table-responsive">
            <!--<table class="table table-striped table-bordered table-hover" style="font-size:small; word-wrap:normal;">
            <thead>
              <tr>
                <th (click)="sort('rowNum')" [class.sorted]="sortColumn === 'rowNum'">{{ sortColumn === 'rowNum' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}Sr.No</th>
                <th (click)="sort('dateofSubmission')" [class.sorted]="sortColumn === 'dateofSubmission'">{{ sortColumn === 'dateofSubmission' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}Date of Submission</th>
                <th (click)="sort('udyamNumber')" [class.sorted]="sortColumn === 'udyamNumber'">{{ sortColumn === 'udyamNumber' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} UDYAM Number</th>
                <th (click)="sort('msmeName')" [class.sorted]="sortColumn === 'msmeName'">{{ sortColumn === 'msmeName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Enterprise Name</th>
                <th (click)="sort('districName')" [class.sorted]="sortColumn === 'districName'">{{ sortColumn === 'districName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} District</th>
                @if (!isIAComment)
                {
                <th (click)="sort('status')" [class.sorted]="sortColumn === 'status'">{{ sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Status</th>

                }
                @if (!isIAComment)
                {
                <th>Other Details</th>
                }
                <th hidden="hidden">MsMeId</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of dataSource">
                <td>{{ item.rowNum }}</td>
                <td>{{ item.dateofSubmission }}</td>
                <td>{{ item.udyamNumber }}</td>
                <td>{{ item.msmeName }}</td>
                <td>{{ item.districName }}</td>
                @if (!isIAComment)
                {
                <td>
                  {{ item.status }}<br />
                  <button *ngIf="item.status === 'Approved' || item.status === 'Rejected' || item.status === 'Verification Pending' || item.status === 'Rejected for Query'"
                          [ngClass]="{
        'btn-success': item.status === 'Approved',
        'btn-danger': item.status === 'Rejected',
        'btn-info': item.status === 'Verification Pending',
        'btn-warning': item.status === 'Rejected for Query'
      }"
                          class="btn btn-sm"
                          (click)="action(item.msmeUserId, item.status === 'Verification Pending' ? 'update' : 'view')">
                    <i [ngClass]="{
      'bi-eye': item.status !== 'Verification Pending',
      'bi-check-circle': item.status === 'Verification Pending'
    }"></i>
                    {{ item.status === 'Verification Pending' ? 'Verify' : 'View' }}
                  </button>-->
            <!--<button *ngIf="item.status === 'Approved'" class="btn btn-success btn-sm" (click)="action(item.msmeUserId,'view')"><i class="bi bi-eye"></i> View</button>
    <button *ngIf="item.status === 'Rejected'" class="btn btn-danger btn-sm" (click)="action(item.msmeUserId,'view')"><i class="bi bi-eye"></i> View</button>
    <button *ngIf="item.status === 'Verification Pending'" class="btn btn-info btn-sm" (click)="action(item.msmeUserId,'update')"><i class="bi bi-check-circle"></i> Verify</button>
    <button *ngIf="item.status === 'Rejected for Query'" class="btn btn-warning btn-sm" (click)="action(item.msmeUserId,'update')"><i class="bi bi-eye"></i> View</button>-->
            <!--</td>
          }
          @if (!isIAComment)
          {
          <td>
            <button class="btn btn-primary btn-sm" (click)="showOtherDetail(item.msmeid)"><i class="bi bi-eye-fill"></i> Show</button>
          </td>
          }
          <td hidden="hidden">{{item.msmeid}}</td>
        </tr>
      </tbody>
    </table>-->
            <!--<table mat-table [dataSource]="dataSource" class="custom-table" matTableResponsive matSort matSortActive="createdDate" matSortDirection="desc" matSortDisableClear>-->
            <table mat-table [dataSource]="dataSource1" class="table table-striped table-bordered table-hover" matTableResponsive matSort matSortActive="createdDate" matSortDirection="desc" matSortDisableClear>
              <!--Sr.No Column-->
              <ng-container matColumnDef="rowNum">
                <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
                <td mat-cell *matCellDef="let item" class="custom-cell"> {{ item.rowNum }} </td>
              </ng-container>
              <!--Date of Submission Column-->
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Submission </th>
                <td mat-cell *matCellDef="let item" class="custom-cell"> {{ item.dateofSubmission }} </td>
              </ng-container>
              <!--UDYAM Number Column-->
              <ng-container matColumnDef="udyamRegistrationNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> UDYAM Number </th>
                <td mat-cell *matCellDef="let item" class="custom-cell">
                  <a (click)="action(item.msmeUserId, getActionType(item.status))"
                     class="text-primary text-decoration-underline"
                     style="cursor: pointer;">
                    {{ item.udyamNumber }}
                  </a>
                </td>
              </ng-container>

              <!--Enterprise Name Column-->
              <ng-container matColumnDef="nameOfEnterprise">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Enterprise Name </th>
                <td mat-cell *matCellDef="let item" class="custom-cell"> {{ item.msmeName }} </td>
              </ng-container>
              <!--District Column-->
              <ng-container matColumnDef="districtName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> District Name </th>
                <td mat-cell *matCellDef="let item" class="custom-cell"> {{ item.districtName }} </td>
              </ng-container>
              <!--Status Column-->
              <ng-container *ngIf="!isIAComment" matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let item" class="custom-cell">
                  <span [ngClass]="{
        'status-approved': item.status === 'Approved',
        'status-rejected': item.status === 'Rejected',
        'status-pending': item.status === 'Verification Pending',
        'status-query': item.status === 'Rejected for Query'
      }">
                    {{ item.status }}
                  </span>
                  <br />
                  <button *ngIf="item.status === 'Approved'" class="btn btn-success btn-sm" (click)="action(item.msmeUserId,'view')"><i class="bi bi-eye"></i> View</button>
                  <button *ngIf="item.status === 'Rejected'" class="btn btn-danger btn-sm" (click)="action(item.msmeUserId,'view')"><i class="bi bi-eye"></i> View</button>
                  <button *ngIf="item.status === 'Verification Pending'" class="btn btn-info btn-sm" (click)="action(item.msmeUserId,'update')"><i class="bi bi-check-circle"></i> Verify</button>
                  <button *ngIf="item.status === 'Rejected for Query'" class="btn btn-warning btn-sm" (click)="action(item.msmeUserId,'update')"><i class="bi bi-eye"></i> View</button>
                  <!--<button *ngIf="['Approved', 'Rejected', 'Verification Pending', 'Rejected for Query'].includes(item.status)"
              class="custom-button"
              (click)="action(item.msmeUserId, item.status === 'Verification Pending' ? 'update' : 'view')">
        <i class="custom-icon"></i>
        {{ item.status === 'Verification Pending' ? 'Verify' : 'View' }}
      </button>-->
                </td>
              </ng-container>
              <!--Other Details Column-->
              <ng-container *ngIf="!isIAComment" matColumnDef="otherDetails">
                <th mat-header-cell *matHeaderCellDef> Other Details </th>
                <td mat-cell *matCellDef="let item" class="custom-cell text-center">
                  <!--<button class="custom-button" (click)="showOtherDetail(item.msmeid)">
        <i class="custom-icon"></i> Show
      </button>-->
                  <button class="btn btn-primary btn-sm" (click)="showOtherDetail(item.msmeid)"><i class="bi bi-eye-fill"></i> Show</button>
                </td>
              </ng-container>
              <!--Hidden MsMeId Column-->
              <ng-container matColumnDef="msmeid">
                <td mat-cell *matCellDef="let item" hidden> {{ item.msmeid }} </td>
              </ng-container>
              <!--Table Header and Rows-->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="totalItems"
                         [pageSize]="pageSize"
                         [disabled]="disabled"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>

        </div>
      </div>
    </form>
  </div>
</div>

